<div>
	<cdx-svg-icon *ngIf="name" [name]="name" [fill]="iconFill" [size]="iconSize || size"></cdx-svg-icon>
	<ng-content *ngIf="!name"></ng-content>
</div>